/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.SoundToTextAnswers.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.SoundToTextAnswers.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.button = null;
  this.answers = [];
  this.correctAnswers = 0;
};

EDC.Games.SoundToTextAnswers.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.SoundToTextAnswers.Scenes.Main.prototype.constructor = EDC.Games.SoundToTextAnswers.Scenes.Main;

const STTA = EDC.Games.SoundToTextAnswers.Scenes.Main.prototype;

STTA.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

STTA.loadIteration = function () {
  this.createButton();
  this.createAnswers();
};

STTA.createAnswers = function () {
  const { answers } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { solution } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const font = {
    font: `${this.gameConfig.answerSize} ${this.gameConfig.font}`,
  };
  for (let i = 0; i < answers.length; i++) {
    const container = this.add.container(280, 290 + i * 200);
    const text = this.add.text(0, 0, answers[i], font).setOrigin(0.5);
    container.add(text);
    container.setSize(350, 120);
    if (solution.indexOf(i + 1) !== -1) {
      container.isCorrect = true;
    } else {
      container.isCorrect = false;
    }
    container.setInteractive();
    const markAnim = new AnswerMark(this, container).setScale(0.35);
    container.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(container);
    container.on('pointerup', this.checkAnswer.bind(this, container), this);
    this.answers.push(container);
  }
};

STTA.checkAnswer = function (answer) {
  const { solution } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  if (answer.isCorrect) {
    this.playCorrect();
    answer.getData('markAnim').showMark(true, () => {});
    answer.disableInteractive();
    this.correctAnswers = this.correctAnswers + 1;
    if (this.correctAnswers === solution.length) {
      this.answers.map(x => x.disableInteractive());
      this.button.scaleAnim.stop();
      this.button.setScale(1);
      this.time.delayedCall(2000, this.shrinkAnimation, [], this);
    }
  } else {
    this.playWrong();
    answer.getData('markAnim').showMark(false, () => {});
    answer.getAt(0).setTint(0xff0000);
    answer.disableInteractive();
  }
};

STTA.shrinkAnimation = function () {
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.answers.map((x) => {
      this.tweens.add({
        targets: x,
        scaleX: '+=0.2',
        scaleY: '+=0.2',
        duration: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
      this.tweens.add({
        targets: x,
        scaleX: 0,
        scaleY: 0,
        duration: 500,
        delay: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
    });
    this.time.delayedCall(1100, this.nextIteration, [], this);
  }
};

STTA.nextIteration = function () {
  this.answers.map((x) => {
    x.destroy();
  });
  this.answers = [];
  this.button.destroy();
  this.button = null;
  this.correctAnswers = 0;
  this.loadIteration();
};

STTA.createButton = function () {
  const { question } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const button = this.add.sprite(1210, 570, 'button-play');
  button.soundKey = this.gameConfig.assets[question].id;
  button.setInteractive();
  this.cursorManager.setDefaultDraggableEvents(button);
  button.on('pointerup', this.playSound.bind(this, button), this);
  this.scaleAnimation(button);
  this.button = button;
};

STTA.scaleAnimation = function (sprite, delay) {
  let randomDelay = delay;
  if (!delay) {
    randomDelay = 300;
  }
  sprite.scaleAnim = this.tweens.add({
    targets: sprite,
    scaleX: 1.1,
    scaleY: 1.1,
    duration: 400,
    ease: 'Linear',
    delay: randomDelay,
    yoyo: true,
    onComplete: this.scaleAnimation.bind(this, sprite, 6000 + Math.floor(Math.random() * 3000)),
  });
};

STTA.playSound = function (button) {
  const musicArray = this.sound.getAll();
  musicArray.map((x) => {
    x.setVolume(0.1);
  });
  const music = this.sound.add(`sound-${button.soundKey}`);
  music.play();
  music.once('complete', (music) => {
    const musicArray = this.sound.getAll();
    musicArray.map((x) => {
      x.setVolume(1);
    });
    music.destroy();
  });
};

STTA.createTemplateUI = function () {
  let title;
  let instructions;
  const { titleImg } = this.gameConfig;
  const { instructionsImg } = this.gameConfig;
  if (titleImg) {
    title = this.add.sprite(1030, 225, 'title').setOrigin(0.5);
  } else {
    title = this.make.text({
      x: 1030,
      y: 200,
      text: this.gameConfig.titleTxt,
      origin: { x: 0.5, y: 0.5 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.titleSize}`,
        wordWrap: { width: '1100' },
        lineSpacing: 0,
        align: 'center',
      },
    });
  }
  if (instructionsImg) {
    instructions = this.add.sprite(1260, 945, 'instructions').setOrigin(0.5);
  } else {
    instructions = this.make.text({
      x: 1260,
      y: 945,
      text: this.gameConfig.instructionsTxt,
      origin: { x: 0.5, y: 0.5 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.instructionsSize}`,
        wordWrap: { width: `${this.gameConfig.instructionsMaxWidth}` },
        lineSpacing: 5,
      },
    });
  }
  const croc = this.add.sprite(480, 715, 'croc').setOrigin(0.1, 0.5);
  const ladder = this.add.sprite(280, 600, 'ladder-choices');
  this.crocAnimation(croc);
};

STTA.crocAnimation = function (sprite) {
  const probability = Math.random() * 100;
  if (probability > 50) {
    this.tweens.add({
      targets: sprite,
      angle: 6,
      duration: 500,
      ease: 'Linear',
      yoyo: true,
      delay: 5000 + Math.floor(Math.random() * 4000),
      onComplete: this.crocAnimation.bind(this, sprite),
    });
  } else {
    this.tweens.add({
      targets: sprite,
      x: sprite.x + 50,
      y: sprite.y + 10,
      duration: 450,
      ease: 'Linear',
      yoyo: true,
      delay: 6000 + Math.floor(Math.random() * 5000),
      onComplete: this.crocAnimation.bind(this, sprite),
    });
  }
};

export default EDC.Games.SoundToTextAnswers.Scenes.Main;
